import { createAction } from "@cobuildlab/react-simple-state";
import { OnFetchLeaders, OnFetchLeadersError } from "./leaders-events";
import { fetchLeaders } from "./leaders-services";

export const fetchLeadersAction = createAction(
  OnFetchLeaders,
  OnFetchLeadersError,
  fetchLeaders
);
